import {
    InformedConsentListQuery,
    InformedConsentData,
    InformedConsentCreationParams,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/informed-consent';

export class InformedConsentApi {
    public static async create(informedConsent: InformedConsentCreationParams): Promise<void> {
        await axios.post(BASE_URL, { informedConsent });
    }

    public static async send(informedConsentId: string): Promise<void> {
        await axios.post(`${BASE_URL}/${informedConsentId}/send`);
    }

    public static async getList(params: InformedConsentListQuery): Promise<InformedConsentData[]> {
        const res = await axios.get(BASE_URL, { params });

        return res.data.informedConsents;
    }
}
